module.exports = __webpack_public_path__ + "media/images/logo-eed11d456c2737a896766c8eaa924716.png";